import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import Input from './Input';

const CustomSelect = props => {
  const CustomSelect = dynamic(() => import('./CustomSelect.js'), {
    ssr: false,
    loading: () => <Input placeholder={props.placeholder} type="text" />,
  });
  return <CustomSelect {...props} />;
};

CustomSelect.propTypes = {
  placeholder: PropTypes.string,
};

CustomSelect.defaultProps = {
  placeholder: '',
};

export default CustomSelect;
